import { useRequest } from "hooks";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { FailedPhoneVerificationsResponse } from "../types";
import { getFailedPhoneVerificationsThunk } from "../thunks";
import { changeExportFailedPhoneVerificationsLoading as changeExportLoading } from "../slice";

export const useFailedPhoneVerificationsActions = () => {
    const getFailedPhoneVerifications = useRequest<
        ThunkReturnType<FailedPhoneVerificationsResponse>,
        string | undefined
    >({
        thunk: getFailedPhoneVerificationsThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetFailedPhoneVerifications
    });

    return {
        getFailedPhoneVerifications,
        downloadCsv
    };
};

export default useFailedPhoneVerificationsActions;
